import React from 'react'

const TicketIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="42" height="42" viewBox="0 0 60 60" {...props}>
    <circle cx="30" cy="30" r="30" fill="#DA291C" />

    <g
      clipPath="url(#clip0)"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none">
      <path d="M27 23.25v13.5" />
      <path d="M20.25 33c.796 0 1.559-.316 2.121-.879A2.997 2.997 0 0 0 23.25 30c0-.796-.316-1.559-.879-2.121A2.997 2.997 0 0 0 20.25 27V24c0-.199.079-.39.22-.53.14-.141.331-.22.53-.22h18c.199 0 .39.079.53.22.141.14.22.331.22.53v3a3 3 0 0 0 0 6v3c0 .199-.079.39-.22.53a.75.75 0 0 1-.53.22h-18a.75.75 0 0 1-.75-.75V33Z" />
    </g>

    <defs>
      <clipPath id="clip0">
        <rect width="24" height="24" transform="translate(18 18)" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
)

export default TicketIcon
